import { useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";

import "./App.css";
import useLenis from "./hooks/useLenis";
import Nav from "./components/Nav";
import Hero from "./components/sections/Hero";
import Problem from "./components/sections/Problem";
import Insight from "./components/sections/Insight";
import Solution from "./components/sections/Solution";
import Services from "./components/sections/Services";
import About from "./components/sections/About";
import FinalCTA from "./components/sections/FinalCTA";
import Footer from "./components/sections/Footer";
import ContactDialog from "./components/ContactDialog";

function Home() {
  useLenis();
  const [open, setOpen] = useState(false);
  const [interest, setInterest] = useState(null);

  const openContact = (i = null) => {
    setInterest(typeof i === "string" ? i : null);
    setOpen(true);
  };

  return (
    <div className="App" data-testid="home-page">
      <Nav onContactOpen={() => openContact()} />
      <main>
        <Hero onContactOpen={() => openContact()} />
        <Problem />
        <Insight />
        <Solution />
        <Services onContactOpen={openContact} />
        <About />
        <FinalCTA onContactOpen={() => openContact()} />
      </main>
      <Footer onContactOpen={() => openContact()} />
      <ContactDialog open={open} onOpenChange={setOpen} interest={interest} />
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0F172A",
            color: "#F9F6F0",
            border: "1px solid #1E293B",
            borderRadius: 0,
          },
        }}
      />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        {/* Catch-all: redirect any legacy / unknown URL to homepage */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
